module.exports = __webpack_public_path__ + "img/19CreekRd_51_57WVine_Small.dc63a487.png";